import React, { useState } from 'react';
import { Button, Panel, Stack } from 'rsuite';
import { PointAccount } from '@/models/point-account.model';
import FundDrawer from './fund-drawer';
import AdjustDrawer from './adjust-drawer';

interface Props {
  account: PointAccount;
  onChanged: () => void;
}

const Figure: React.FC<{ label: string; value: number; color?: string }> = ({ label, value, color }) => (
  <div style={{ minWidth: 140 }}>
    <div style={{ color: '#888', fontSize: 12 }}>{label}</div>
    <div style={{ fontSize: 24, fontWeight: 600, color }}>{value.toLocaleString()}</div>
  </div>
);

const PointAccountBalance: React.FC<Props> = ({ account, onChanged }) => {
  const [openFund, setOpenFund] = useState(false);
  const [openAdjust, setOpenAdjust] = useState(false);

  return (
    <Panel bordered style={{ margin: '16px 0' }}>
      <Stack justifyContent="space-between" wrap spacing={16}>
        <Stack spacing={32} wrap>
          <Figure label={`Balance (${account.pointTypeName ?? 'points'})`} value={account.balance} color="#2db85d" />
          <Figure label="Total Funded" value={account.totalFunded} />
          <Figure label="Total Granted" value={account.totalGranted} />
        </Stack>
        <Stack spacing={6}>
          <Button appearance="primary" onClick={() => setOpenFund(true)}>Fund</Button>
          <Button appearance="ghost" onClick={() => setOpenAdjust(true)}>Adjust</Button>
        </Stack>
      </Stack>
      <FundDrawer open={openFund} pointAccountId={account.id}
        onClose={() => setOpenFund(false)} onSubmitted={() => { setOpenFund(false); onChanged(); }} />
      <AdjustDrawer open={openAdjust} pointAccountId={account.id}
        onClose={() => setOpenAdjust(false)} onSubmitted={() => { setOpenAdjust(false); onChanged(); }} />
    </Panel>
  );
};

export default PointAccountBalance;
